import axios from 'axios';

const clienteAxiosAdmin = axios.create({
    baseURL : process.env.REACT_APP_BACKEND_ADMIN_URL
});

export default clienteAxiosAdmin;